import { Component, OnInit, ElementRef, Output, EventEmitter, ViewChild, NgZone, HostListener } from '@angular/core';

declare let window:any;

@Component({
  selector: 'vq-infinite-scroll',
  templateUrl: './infinite-scroll.component.html',
  styleUrls: ['./infinite-scroll.component.scss']
})
export class InfiniteScrollComponent implements OnInit {

  // component based on this answer
  // https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
  @ViewChild('trigger') trigger: ElementRef;
  @Output('trigger') load:EventEmitter<any> = new EventEmitter<any>();

  old_visible:boolean;

  constructor(
  	private _zone:NgZone
  ) { }

  ngOnInit() {
    this.handler();
  }

  _isElementInViewport() {  
    console.log(this.trigger);
    let rect = this.trigger.nativeElement.getBoundingClientRect();  
  	return (
  	  rect.top >= 0 &&
  	  rect.left >= 0 &&
  	  rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
  	  rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
  	);
  }

  _onVisibilityChange(callback) {
    let visible = this._isElementInViewport();
    if (visible != this.old_visible) {
      this.old_visible = visible;
      callback(visible);
    }
  }  

  @HostListener("window:scroll", [])
  // @HostListener("window:load", [])
  // @HostListener("window:resize", [])
  handler() {
    console.log('here')
    this._onVisibilityChange((visible) => {
      this.load.emit(visible);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/vqutils/infinite-scroll/infinite-scroll.component.ts